import React from 'react';

interface VersionHistoryFooterProps {
  historyInfo: string;
  onUpdateClick: () => void;
  styles?: React.CSSProperties;
  disabled?: boolean; // when true, the update action is disabled
}

const VersionHistoryFooter: React.FC<VersionHistoryFooterProps> = ({
  historyInfo,
  onUpdateClick,
  styles,
  disabled = false,
}) => {
  return (
    <div className="h-version-history" style={styles}>
      {historyInfo && (
        <div className="h-version-history__info">{historyInfo}</div>
      )}

      <div className="h-version-history__update-btn">
        <a
          role="button"
          aria-disabled={disabled}
          tabIndex={disabled ? -1 : 0}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            onUpdateClick();
          }}
          className={disabled ? 'is-disabled' : undefined}
          style={disabled ? { opacity: 0.6, cursor: 'not-allowed' } : undefined}
        >
          update data
        </a>
      </div>
    </div>
  );
};

export default VersionHistoryFooter;
